<template>
    <div id="buyingManagement" class="page-content">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>买货登记</el-breadcrumb-item>
            <el-breadcrumb-item>余额管理</el-breadcrumb-item>
        </el-breadcrumb>

        <section class="seaerch-wrapper">
            <el-form class="search-form" :model="queryParams" ref="queryForm">
                <el-form-item label="收入/支出日期" prop="dateRange" label-width="110px">
                    <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" size="small"
                        @change="dataChange"></el-date-picker>
                </el-form-item>

                <el-form-item label="品牌" prop="brandname" label-width="100px">
                    <el-select v-model="queryParams.brandname" filterable clearable placeholder="请选择品牌" size="small">
                        <el-option v-for="item in dispensabilityData" :key="item.bmcid"
                            :label="item.company_memoname ? item.company_memoname : item.companyname"
                            :value="item.company_memoname">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label-width="100px">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                </el-form-item>
            </el-form>
        </section>

        <div style="background-color: white;padding: 20px;">
            <el-row :gutter="10" class="mb8" style="padding-bottom: 20px;">
                <el-col :span="1.5">
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">管理</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="importTemplate">下载数据</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="changeHistory">变更历史</el-button>
                </el-col>
                <el-col :span="1.5">
                    <el-button size="mini" @click="updateyue">更新余额明细</el-button>
                </el-col>
            </el-row>

            <el-table v-loading="loading" :data="tableData" @row-click="taskidFun">
                <el-table-column label="品牌" align="left" key="brandname" prop="brandname" />
                <el-table-column label="交易类型" align="left" key="transactiontype" prop="transactiontype" />
                <el-table-column label="收入/支出日期" align="left">
                    <template slot-scope="scope" v-if="scope.row.tradingdate">
                        {{ scope.row.tradingdate | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="收入/支出账号" align="left" key="tradingaccount" prop="tradingaccount" />
                <el-table-column label="收入/支出金额" align="left" key="tradingprice" prop="tradingprice" />
                <el-table-column label="收入/支出截图" align="left">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="更多图片" width="200" trigger="hover">
                            <div style="display: flex;">
                                <img v-for="(url, index) in parseScreenshots(scope.row.tradingscreenshot)" :key="index"
                                    :src="url" alt
                                    style="width: 50px; height: 50px; cursor: pointer;float: left;margin-left: 10px;"
                                    @click.stop="bigImg(url)" />
                            </div>
                            <img slot="reference" :src="parseScreenshots(scope.row.tradingscreenshot)[0]" alt
                                style="width: 50px; height: 50px; cursor: pointer;"
                                @click.stop="bigImg(parseScreenshots(scope.row.tradingscreenshot)[0])" />
                        </el-popover>
                    </template>
                    <!-- <template slot-scope="scope">
                        <img :src="scope.row.tradingscreenshot" alt style="width: 50px;height: 50px;cursor: pointer;"
                            v-if="scope.row.tradingscreenshot" @click.stop="bigImg(scope.row.tradingscreenshot)">
                    </template> -->
                </el-table-column>
                <el-table-column label="创建人" align="left" key="createuser" prop="createuser" />
                <el-table-column label="创建时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.createtime">
                        {{ scope.row.createtime | fullTime }}
                    </template>
                </el-table-column>
                <el-table-column label="更新人" align="left" key="updateuser" prop="updateuser" />
                <el-table-column label="更新时间" align="left">
                    <template slot-scope="scope" v-if="scope.row.updatetime">
                        {{ scope.row.updatetime | fullTime }}
                    </template>
                </el-table-column>
            </el-table>
            <div v-show="this.tableData.length > 0">
                <pagination :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]" :total="totalNum"
                    @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
                </pagination>
            </div>
        </div>

        <el-dialog title="图片详情" :visible.sync="bigOpen">
            <div style="text-align: center;">
                <img :src="bigurl" style="width: 400px;height: auto;">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bigOpen = false" size="small">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="更新余额明细" :visible.sync="balanceShow" width="520px">
            <el-form label-width="70px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="时间" required>
                            <el-date-picker v-model="dateRange2" value-format="yyyy-MM-dd" type="daterange"
                                style="width: 410px;" range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="balanceDetails">确 定</el-button>
                <el-button @click="balanceShow = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="title" :visible.sync="open" width="620px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="150px"
                style="height: 500px;overflow: auto;margin-top: 20px;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="品牌" prop="brandname">
                            <el-select v-model="form.brandname" filterable clearable placeholder="请选择品牌"
                                style="width: 410px;" size="small" @change="changeBrand">
                                <el-option v-for="item in dispensabilityData" :key="item.bmcid"
                                    :label="item.company_memoname ? item.company_memoname : item.companyname"
                                    :value="item.company_memoname">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="交易类型" prop="transactiontype">
                            <el-select v-model="form.transactiontype" clearable placeholder="请选择交易类型"
                                style="width: 410px;" size="small" :disabled="title == '余额管理详情' && form.transactiontype == '初始金额'">
                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="收入/支出日期" prop="tradingdate">
                            <el-date-picker v-model="form.tradingdate" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择收入/支出日期" style="width: 410px;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="收入/支出账号" prop="tradingaccount">
                            <el-input v-model="form.tradingaccount" clearable placeholder="请填写收入/支出账号"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="收入/支出截图" prop="tradingscreenshot">
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in tradingscreenshot" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index)"></i>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="收入/支出金额" prop="tradingprice">
                            <el-input v-model="form.tradingprice" clearable placeholder="请填写收入/支出金额"
                                style="width: 410px;" size="small" type="number" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel(2)">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import pagination from "../../../components/dataTable/pagination";
export default {
    name: "balanceManagement",
    components: {
        pagination
    },
    data() {
        return {
            balanceShow: false,
            elUpload: true,
            queryParams: {
                pageNo: 1,
                pageSize: 10,
                brandname: null,
            },
            title: '',
            totalNum: 0,
            currentPage: 0,
            dateRange: [],
            dateRange2: [],
            loading: false,
            tableData: [],
            // 表单参数
            form: {},
            taskData: [],
            returnData: [],
            returnList: [],
            bigurl: '',
            open: false,
            bigOpen: false,
            dispensabilityData: [],
            allOptions: [{
                label: '初始金额',
                value: '初始金额',
            }, {
                label: '补充金额',
                value: '补充金额',
            }, {
                label: '退还品牌',
                value: '退还品牌',
            }],
            allOptions2: [{
                label: '补充金额',
                value: '补充金额',
            }, {
                label: '退还品牌',
                value: '退还品牌',
            }],
            options: [],
            rules: {
                brandname: [
                    { required: true, message: '请选择品牌', trigger: 'blur' },
                ],
                transactiontype: [
                    { required: true, message: '请选择交易类型', trigger: 'blur' },
                ],
                tradingdate: [
                    { required: true, message: '请选择收入/支出日期', trigger: 'blur' },
                ],
                tradingaccount: [
                    { required: true, message: '请填写收入/支出账号', trigger: 'blur' },
                ],
                tradingscreenshot: [
                    { required: true, message: '请选择收入/支出截图', trigger: 'blur' },
                ],
                tradingprice: [
                    { required: true, message: '请填写收入/支出金额', trigger: 'blur' },
                ]
            },
            tradingscreenshot: [],
        };
    },
    created() {
        this.getList();
        this.getBmcByName();
    },
    methods: {
        // 打开更新余额明细
        updateyue() {
            this.dateRange2 = [];
            this.balanceShow = true;
        },
        balanceDetails() {
            if (this.dateRange2.length == 0) {
                this.$message({
                    message: '请先选择时间',
                    type: 'warning'
                });
                return;
            }
            let begintime = this.dateRange2[0] ? this.dateRange2[0] : null
            let endtime = this.dateRange2[1] ? this.dateRange2[1] : null
            let params = {
                begintime: begintime,
                endtime: endtime
            }
            fetch({
                url: "hcm/hcmBalanceManagementsummary/syncBalanceManagementsummary",
                method: "post",
                data: params,
                noFormat: true,
                responseType: "text"
            })
                // fetch({
                //     url: "hcm/hcmBalanceManagementsummary/syncBalanceManagementsummary",
                //     method: "post",
                //     data: JSON.stringify(params),
                //     headers: {
                //         'Content-Type': 'application/json',
                //     },
                //     noFormat: false,
                //     responseType: "json"
                // })
                .then((res) => {
                    if (res.status === '10000') {
                        this.$message({
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getList();
                        this.open = false;
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    this.$message.error('服务器出错');
                });

        },
        parseScreenshots(screenshotString) {
            return screenshotString.split(',');
        },
        delIcon(index) {
            this.tradingscreenshot.splice(index, 1)
        },
        changeBrand() {
            for (let a in this.dispensabilityData) {
                if (this.dispensabilityData[a].company_memoname == this.form.brandname || this.dispensabilityData[a].companyname == this.form.brandname) {
                    this.form.bmcid = this.dispensabilityData[a].bmcid
                }
            }
            console.log(this.form.bmcid)
        },
        getBmcByName() {
            // let params = {
            //     name: this.form.brandname,
            //     type: "brm"
            // }
            fetch({
                url: "/hcm/userin/getBmcListByKefuid",
                method: "get",
                // params: params,
                noFormat: true,
                responseType: "text"
            }).then(result => {
                let res = JSON.parse(result);
                let { data } = res
                if (res.status == '10000') {
                    this.dispensabilityData = []
                    if (res.data.length > 0) {
                        this.dispensabilityData = res.data
                    } else {
                        this.$message({
                            message: '暂无当前用户',
                            type: 'warning'
                        });
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        handleUploadSuccess(res) {
            this.tradingscreenshot.push(res.data.data);
            this.form.tradingscreenshot = ''
            this.form.tradingscreenshot = this.tradingscreenshot.join(',');
            this.elUpload = false;
        },
        bigImg(img) {
            this.bigurl = img;
            this.bigOpen = true;
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    fetch({
                        url: "hcm/hcmBalanceManagement/save",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.getList();
                            this.open = false;
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        cancel() {
            this.open = false;
        },
        dataChange() {
            if (!this.dateRange) {
                this.dateRange = []
            }
            this.queryParams.begintime = this.dateRange[0] ? this.dateRange[0] : null
            this.queryParams.endtime = this.dateRange[1] ? this.dateRange[1] : null
        },
        parentMethod() {
            this.getList();
        },
        // 变更历史
        changeHistory() {
            this.$router.push({
                path: '/salesRegistration/buyingHistory',
                query: { modulename: 'YE', name: '余额管理', url: '/salesRegistration/buyingManagement/index' }
            })
        },
        // 展示详情
        taskidFun(data) {
            this.form = data;
            this.tradingscreenshot = this.form.tradingscreenshot.split(',');
            this.form.tradingdate = this.$options.filters.fullTime(data.tradingdate);
            this.title = "余额管理详情";
            this.options = this.allOptions2;
            this.open = true;
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNo = 1;
            this.dataChange();
            this.getList();
        },
        // 数据源
        getList() {
            this.loading = true;
            fetch({
                url: "hcm/hcmBalanceManagement/getListOrder",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.tableData = result.data.content;
                    this.totalNum = result.data.totalElements;
                    this.loading = false;
                }
            })
        },
        // 下载数据
        importTemplate() {
            fetch({
                url: "hcm/hcmBalanceManagement/downBalanceManagementDownload",
                method: "get",
                params: this.queryParams,
                noFormat: true,
                responseType: "blob"
            }).then((res) => {
                //下载
                let url = window.URL.createObjectURL(new Blob([res]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '余额管理.xlsx')
                document.body.appendChild(link)
                link.click()
            })
        },
        // 新增
        handleAdd() {
            this.title = "管理录入";
            this.options = this.allOptions;
            this.form = {};
            this.tradingscreenshot = [];
            this.open = true;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = `${val}`
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNo = `${val}`
            this.getList();
        },
    }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#buyingManagement {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>